module.exports = __webpack_public_path__ + "media/images/application/template/select-arrow-down-7618a8d720f7a7094e82a8223e668620.svg";